export default __webpack_public_path__ + "images/b450b5a5ea89b32b5729815bbfea6e32-minus.svg";